import React, { SVGAttributes } from 'react';

export function ShieldCheck(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      role='img'
      {...props}
    >
      <title>Shield Check Icon</title>
      <g id='vector'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.8491 2.1373C10.379 0.81132 5.62005 0.811413 1.14995 2.13758L0.987428 1.58974L1.15101 2.13727C1.14866 2.13797 1.1466 2.13941 1.14513 2.14138C1.1437 2.14328 1.14291 2.14558 1.14286 2.14795V5.13383C1.14281 7.23137 1.77844 9.27969 2.96595 11.0087C4.15345 12.7377 5.83707 14.0662 7.7948 14.819C7.92685 14.8698 8.07309 14.8698 8.20514 14.819C10.1629 14.0662 11.8465 12.7377 13.0341 11.0087C14.2216 9.27969 14.8572 7.23138 14.8571 5.13383V2.14797C14.8571 2.14559 14.8563 2.14329 14.8549 2.14138C14.8534 2.13944 14.8514 2.13802 14.8491 2.1373ZM0.824905 1.0419C5.50744 -0.347299 10.4926 -0.347299 15.1751 1.0419L15.1762 1.04221C15.4136 1.11316 15.6219 1.25864 15.7703 1.45715C15.9186 1.65566 15.9992 1.89664 16 2.14447L16 2.14633L16 5.13383C16.0001 7.46239 15.2944 9.7363 13.9761 11.6557C12.6578 13.5752 10.7887 15.05 8.61538 15.8857C8.21927 16.0381 7.78073 16.0381 7.38462 15.8857C5.21125 15.05 3.3422 13.5752 2.02389 11.6557C0.705592 9.7363 -5.27273e-05 7.46239 2.95504e-09 5.13383V2.14447C0.000804745 1.89664 0.0813495 1.65566 0.229716 1.45715C0.378083 1.25864 0.586396 1.11316 0.823846 1.04221L0.824905 1.0419Z'
          fill='#594F00'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.7207 4.15921C12.0387 4.41254 12.0932 4.87832 11.8425 5.19956L7.94982 10.1857C7.73285 10.4629 7.39655 10.6669 6.9972 10.6669C6.59785 10.6669 6.26155 10.4629 6.04459 10.1857L6.04331 10.1841L4.1568 7.94965C3.90653 7.62801 3.96177 7.16232 4.2802 6.90951C4.59862 6.6567 5.05964 6.7125 5.30991 7.03415L6.99753 9.01294L10.6908 4.28217C10.9416 3.96093 11.4027 3.90588 11.7207 4.15921Z'
          fill='#594F00'
        />
      </g>
    </svg>
  );
}
